import { Switch } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../redux/PlatfromSettingAction";

export const CompanyGameList = () => {
  const intl = useIntl();
  const indexRef = useRef(0);
  const [swalProps, setSwalProps] = useState({});
  const [platformSettingPermission, setPlatformSettingPermission] =
    useState("");
  const dispatch = useDispatch();
  const platformSettingState = useSelector(
    ({ platformSetting }) => platformSetting,
    shallowEqual
  );
  useEffect(() => {
    indexRef.current = 0;
    const queryParams = {
      action: "companygamelistV2",
    };
    dispatch(actions.callCompanyGameList(queryParams));
  }, []);
  useEffect(() => {
    const storedUserPermission = JSON.parse(
      localStorage.getItem("permissions")
    );

    if (storedUserPermission) {
      storedUserPermission.forEach((permission) => {
        switch (permission.permissioncode) {
          case "platformsetting":
            setPlatformSettingPermission(permission.allow);
            break;
          default:
            break;
        }
      });
    }
  }, []);
  const handleSwitchChange = (checked, code, companytype) => {
    const updateQueryParams = {
      action: "updatecompanygamevisibleV2",
      companycode: code,
      companytype,
    };
    dispatch(actions.updateCompanyGameList(updateQueryParams))
      .then(() => {
        indexRef.current = 0;
        const queryParams = {
          action: "companygamelistV2",
        };
        dispatch(actions.callCompanyGameList(queryParams));
      })
      .catch((error) => {
        console.error("Error updating company game list:", error);
      });
  };

  return (
    <div style={{ width: "95%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div>
        <h2>{intl.formatMessage({ id: "companyGameList" })}</h2>
      </div>
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell text-start">
                    {intl.formatMessage({ id: "companyName" })}
                  </th>
                  <th className="member-cell text-start">
                    {intl.formatMessage({ id: "visible" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {platformSettingState.companyGameList?.companyGameListsV2
                  ?.length > 0 ? (
                  platformSettingState.companyGameList?.companyGameListsV2.map(
                    (game, index) => {
                      const isShowCompanyType =
                        index === 0 ||
                        platformSettingState.companyGameList
                          ?.companyGameListsV2[index - 1].companytype !==
                          game.companytype;

                      return (
                        <React.Fragment key={index}>
                          {isShowCompanyType && (
                            <tr className="member-row1">
                              <td
                                colSpan={2}
                                className="text-start fw-bold ps-1"
                              >
                                {game.companytype}
                              </td>
                            </tr>
                          )}
                          <tr className="member-row1">
                            <td className="member-cell text-nowrap text-start ps-4">
                              {game.companyname}
                            </td>
                            {platformSettingPermission === "true" ? (
                              <td className="member-celltext-nowrap">
                                <Switch
                                  checked={game.isvisible === "true"}
                                  onChange={(checked) =>
                                    handleSwitchChange(
                                      checked,
                                      game.companycode,
                                      game.companytype
                                    )
                                  }
                                />
                              </td>
                            ) : (
                              <td className="member-cell text-nowrap">
                                {game.isvisible === "true"
                                  ? intl.formatMessage({ id: "active" })
                                  : intl.formatMessage({ id: "inactive" })}
                              </td>
                            )}
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <tr>
                    <td colSpan="2">
                      <div className="no-record-wrapper">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
